// GLOBAL STARTER DEPENDENCIES
import $ from 'jquery'
import '../node_modules/bootstrap/dist/js/bootstrap.js'
import '../node_modules/bootstrap-datepicker/dist/js/bootstrap-datepicker.js'
import '../node_modules/timepicker/jquery.timepicker.js'
import '../node_modules/holderjs/holder.js'


import '../node_modules/flickity-imagesloaded/flickity-imagesloaded.js'
import '../node_modules/flickity/dist/flickity.pkgd.js'

require('es6-promise').polyfill();

// import Flickity from 'flickity'

import * as Moment from 'expose-loader?Moment!moment'
import 'expose-loader?Vue!vue'
export {Slider, CraftVue} from './starters'

// PROJECT SPECIFIC DEPENDENCIES

export {initLocationsMap} from './init-locations-map'
export {calendarVueComponent} from './calendar-vue-component'
export {locationsVueComponent} from './locations-vue-component'
export {initBusinessMaps} from './init-business-maps'
export {initEventMap} from './init-event-map'
export {initLocationDetailMap} from './init-location-detail-map'
export {locationCalendarVueComponent} from './location-calendar-vue-component'
export {historyVueComponent} from './history-vue-component'
export {photoswipe} from './photoswipe'
export {photoswipeUi} from './photoswipe-ui-default'
export {slideshow} from './slideshow'
// export {TweenMax} from '../node_modules/gsap/src/minified/TweenMax.min.js'
export {draggabilly} from './draggabilly'
export {scrollmagic} from './scroll-magic'
export {modernizr} from './modernizr-custom'


export {searchVueComponent} from './search-vue.component'
export {advocacyVueComponent} from './advocacy-vue-component'


setTimeout(function(){
  $('body').removeClass('preload');
}, 500);


$('.gallery').flickity({
  cellAlign: 'left',
  contain: true,
  pageDots: false,
  groupCells: true,
  cellSelector: '.gallery-cell',
  percentPosition: false,
  imagesLoaded: true,
  arrowShape: 'M22.6633412,50 L81.25,50 C82.1129449,50 82.8125,49.3004449 82.8125,48.4375 C82.8125,47.5745551 82.1129449,46.875 81.25,46.875 L22.6633412,46.875 L51.076171,19.8828116 C51.7018056,19.2884588 51.7271645,18.2994635 51.1328116,17.673829 C50.5384588,17.0481944 49.5494635,17.0228355 48.923829,17.6171884 L17.673829,47.3046884 C17.0253903,47.9207051 17.0253903,48.9542949 17.673829,49.5703116 L48.923829,79.2578116 C49.5494635,79.8521645 50.5384588,79.8268056 51.1328116,79.201171 C51.7271645,78.5755365 51.7018056,77.5865412 51.076171,76.9921884 L22.6633412,50 Z'
})

// ****************************************************************************
// GLOBAL JAVASCRIPT (COMPILES INTO SCRIPTS-BUNDLE.JS AND SERVED ON EVERY PAGE)
// ****************************************************************************


$('#header').on('mouseenter', function(e){
	e.preventDefault();

  if ($(e.target).hasClass('nav-dark') || $(e.target).parent().hasClass('nav-dark')) {
     return true;
  }

	$('.page-wrapper').addClass('scroll-down');
});

$('#header').on('mouseleave', function(e){
	e.preventDefault();
    if ($(e.target).hasClass('nav-dark')) {
     return true;
  }
	$('.page-wrapper').removeClass('scroll-down');
});

$('.navbar-toggler').on('click', function(e){
	e.preventDefault();
	$('body').toggleClass('menu-open');
});

$('#click-zone').on('click', function(e){
	e.preventDefault();
	$('#newsletter').toggleClass('open');
});

$(function() {

  $('#subnav a').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top -30
        }, 800);
        return false;
      }
    }
  });
});

if(localStorage.getItem("stickersDismissed") != "true") {
  console.log('no stickersDismissed');
  $('#sticker-wrapper').removeClass('closed');
}


$('.sticker-dismiss').on('click', function(e){
	e.preventDefault();
	$('#sticker-wrapper').addClass('closed');
  $('#sticker-toggle').toggleClass('active');

  if ($('html').hasClass('touchevents')) {
    localStorage.setItem("stickersDismissed", "true");
  }
});

$('#sticker-toggle').on('click', function(e){
	e.preventDefault();
	$('#sticker-wrapper').toggleClass('closed');
  $(this).toggleClass('active');
});

// Potential Animation for the homepage person based on mouse position. Turning off for now
// var $win = $(window),
//   w = 0,
//   h = 0,
//   getWidth = function() {
//     w = $win.width();
//     h = $win.height();
//   };
//
// $win.resize(getWidth).mousemove(function(e) {
//
//    var positionW = Math.round(e.pageX/w * 10);
//    var positionH = e.pageY/h * .05;
//
//    var amountX = positionW - 5 ;
//    var amountY = positionH + 1;
//
//    var translate = 'translateX(' + amountX + 'px)'
//    var scale = 'scale(' + amountY + ')'
//
//    $('.person.homepage-img').css({'transform': translate + ' ' + scale});
//
// }).resize();



// WEBPACK FOOTER //
// ./scripts/entry.js